import { render, staticRenderFns } from "./GestioneAttributi.vue?vue&type=template&id=3ff5fd1f&scoped=true&"
import script from "./GestioneAttributi.vue?vue&type=script&lang=js&"
export * from "./GestioneAttributi.vue?vue&type=script&lang=js&"
import style0 from "./GestioneAttributi.vue?vue&type=style&index=0&id=3ff5fd1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5fd1f",
  null
  
)

export default component.exports